/**
 * header
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_header.css';
import './_header.twig';

// Debounce functionality.
const { debounce } = require('lodash');

export const name = 'header';

export const defaults = {
  dummyClass: 'js-header-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { header = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const headers = once('header-init', '.header', $context);
  // Bail if component does not exist
  if (!headers.length) {
    return;
  }

  const $header = $(headers);

  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...header,
  };

  // An example of what could be done with this component
  $header.addClass(settings.dummyClass);

  // Gets the header height to identify how long the scroll should be to hide it.
  const tracker = $('.header__tracker', $header).get(0);

  // Throttled function during window scrolling.
  const debounced = debounce(() => {
    if (!$header.is('.header--active')) {
      const rect = tracker.getBoundingClientRect();
      if (rect.y <= -1) {
        $header.addClass('header--alternate header--in');
      } else {
        $header.removeClass('header--alternate header--in');
      }
    } else {
      $header.removeClass('header--alternate header--in');
    }
  }, 100);
  $(window).on('scroll', debounced);
  $(window).trigger('scroll');

  // Adds menu trigger: open or close menu.
  $(document).on('click', '.header__menu-trigger', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $header
      .toggleClass('header--navigation-on')
      .removeClass('header--utility-on')
      .removeClass('header--lang-on')
      .removeClass('header--lang-mobile-on');
    if ($header.is('.header--navigation-on, .header--utility-on')) {
      $header.addClass('header--active');
      $('body').addClass('overflow-hidden');
    } else {
      $header.removeClass('header--active');
      $header.removeClass('header--active-lang');
      $('body').removeClass('overflow-hidden');
    }

    // Triggers scroll to figure out how to paint the header.
    $(window).trigger('scroll');
  });

  // Adds the search utility trigger.
  $(document).on('click', '.header__utility-trigger', (e) => {
    e.preventDefault();
    e.stopPropagation();


    $header.toggleClass('header--utility-on');
    if ($header.is('.header--navigation-on, .header--utility-on')) {
      $header.addClass('header--active');
      $('body').addClass('overflow-hidden');
    } else {
      $header.removeClass('header--active');
      $header.removeClass('header--active-lang');
      $('body').removeClass('overflow-hidden');
    }

    // Triggers scroll to figure out how to paint the header.
    $(window).trigger('scroll');
  });

  // Add the utility account trigger.
  $(document).on('click', '.header__utility-account', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $header.toggleClass('header--account-on');
    $('.navigation').toggleClass('header--account-on');
  });

  // Triggers the real form submission.
  $('.header__fake-search-form').on(
    'submit',
    function handleSearchFormSubmission() {
      $('.header__content--utility .input--submit').trigger('click');
      return false;
    }
  );

  // Updates the search form when updating the fake search form.
  $(document).on('keyup', '.header__fake-field', (e) => {
    $('.header__content--utility .search__filter--keywords', $header).val(
      $(e.target).val()
    );
  });

  // Updates the search form when updating the fake search form.
  $(document).on(
    'click',
    '.header__utility-wrapper .header__utility-account',
    () => {
      $('.header__utility-account-menu', $header).toggleClass(
        'header__utility-account-menu--active'
      );
    }
  );

  $(document).on('click', '.header__utility-trigger-lang', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $header
      .toggleClass('header--lang-on')
      .removeClass('header--utility-on')
      .removeClass('header--navigation-on');
    if ($header.is('.header--lang-on, .header--utility-on')) {
      // $header.addClass('header--active');
      $header.addClass('header--active-lang');
      $('body').addClass('overflow-hidden');
    } else {
      $header.removeClass('header--active');
      $header.removeClass('header--active-lang');
      $('body').removeClass('overflow-hidden');
    }

    // Triggers scroll to figure out how to paint the header.
    $(window).trigger('scroll');
  });

  $(document).on('click', '.header__utility-trigger-lang-mobile', (e) => {
    e.preventDefault();
    e.stopPropagation();
    $header.toggleClass('header--lang-mobile-on');
    if (!$header.is('.header--lang-mobile-on')) {
      $header.removeClass('header--lang-mobile-on');
    }

    // Triggers scroll to figure out how to paint the header.
    $(window).trigger('scroll');
  });

  const languageSwitcher = $header.find('.language-switcher-language-url');
  if (languageSwitcher.length < 0) {
    $('.header__utility-trigger-lang').hide();
    return;
  }

  languageSwitcher.each(function updateLanguage() {
    $header.addClass('multi-lang');

    // Grab the active langCode the site is on an displays on the UI.
    const langCode = $('li.is-active').attr('hreflang').toUpperCase();
    const langCodeElm = `<span class="header__trigger-icon--utility-lang-open font-bold ml-1">${langCode}</span>`;
    // add langCode to the globe
    $('.header__utility-trigger-lang-mobile').append(langCodeElm);
    $('.header__utility-trigger-lang').append(langCodeElm);
  });
}
export default enable;
